export const TIME_SLOT = 'TIME_SLOT';
export const FLEXIBLE = 'FLEXIBLE';

export const schedulingTypesMessages = {
  [TIME_SLOT]: {
    id: 'Service.Scheduling.SchedulingType.TimeSlot',
    defaultMessage: '** Time slot',
  },
  [FLEXIBLE]: {
    id: 'Service.Scheduling.SchedulingType.Flexible',
    defaultMessage: '** Flexible',
  },
};

